export const loginPage = {
  pageTitle: 'Connexion',
  mainTitle: 'Commencez votre construction avec nous.',
  text: `Pour vous connecter à votre compte personnel, vous devez prendre rendez-vous pour commander un projet. Ensuite, vous recevrez un mot de passe que vous pourrez modifier.`,
  btnText: 'Suivant',
  popupIncorrectText: "Mot de passe ou courriel incorrect",
}; ;